import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@env/environment';

// import { AppBrowserModule } from '@app/app.browser.module';
import { AppModule } from '@app/app.module';
import { APP_CONFIG } from '@app/core/services';

if (environment.production || environment.stage) {
  enableProdMode();
}

function bootstrap(): void {
  platformBrowserDynamic([
    { provide: APP_CONFIG, useValue: { settings: {}, configsUrl: '' } },
  ])
    .bootstrapModule(AppModule)
    .catch(error => console.log(error));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
